module.exports = __webpack_public_path__ + "img/banxico.64d3008d.svg";